import * as React from "react";
import MuiTooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  tooltip: {
    fontSize: "0.75rem"
  }
});

const Tooltip = props => {
  const classes = useStyles();
  return <MuiTooltip classes={classes} arrow {...props} />;
};

export default Tooltip;
